
import {
  Col,
  Form,
  Row,
  Space,
  Typography,
  Upload,
} from "antd";
import GeneralFeedbackCategoriesInput from "apps/Common/GeneralFeedbackCategoriesInput";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { Link } from "react-router-dom";
import { addFeedbackByUser, addMediaByFeedback } from "../Services";
import FeedbackUploader from "./FeedbackUploader";
import { useState } from "react";

const ProblemSuggestionForm = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
const [fileList,setFileList] = useState<any[]>([])
  const handleOnFinish = async() => {
  mazakaForm.setLoading()
  let formValues = form.getFieldsValue()
  formValues["description"] = formValues["description"]||""
  try {

    
   const response = await addFeedbackByUser(formValues)
   if(response?.data?.id && fileList.length>0)
   {
     await addMediaByFeedback({file:fileList[0],feedbackId:response?.data?.id})
  }
   mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
   form.resetFields();
   props.onFinish()
    
  } catch (error:any) {
    openNotificationWithIcon("default",error?.message)
    mazakaForm.setFailed(2000,error?.message)
  }
  };

  const { Text } = Typography;
 



  return (
    <>
     
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[0, 10]} className="!px-4">
            <GeneralFeedbackCategoriesInput
              label="Kategori"
              placeholder="Kategori"
              className="!m-0"
              name="reportCategoryId"
              rules={[{required:true,message:""}]}
           
            />
            <MazakaTextArea
              xs={24}
              name="description"
              label="Açıklama"
              className="!m-0"
              inputClassName="!bg-[#f7f7f7] !p-2"
              placeholder="Açıklama"
            />

            <Col span={24} className="!mt-4">
             <FeedbackUploader fileList={fileList} setFileList={setFileList} />
            </Col>

            <Col span={24}>
              <Space>
                <Text className="text-[#606060] !text-xs">
                  Kişisel verilerimin korunması hakkında detaylı bilgiye{" "}
                  <Link to={"/kisisel-verilerin-korunmasi"}>buradan</Link> ulaşabilirsiniz.
                </Text>
              </Space>
            </Col>

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Gönder
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
    
    </>
  );
};

export default ProblemSuggestionForm;
